<template>
  <b-row v-if="rule" no-gutters cols="1" cols-lg="12" :class="'mb-2 mt-2 ' + rule.type === 'collection'?'':'border-bottom'">
    <template v-if="'selector' in rule && 'destination' in rule && 'action' in rule && 'source' in rule">
      <template v-if="rule.direction === 'out'">
        <b-col lg="4">
          <FWMLv2SelectorViz :selector="rule.selector"/>
        </b-col>
        <b-col lg="4">from
          <FWMLv2LocatorViz :locator="rule.source" :negate="rule.negate_source"/>
        </b-col>
        <b-col lg="1">
          <FWMLv2ActionViz :action="rule.action"/>
        </b-col>
        <b-col class="m-0" lg="3">to
          <FWMLv2LocatorViz :locator="rule.destination" :negate="rule.negate_destination"/>
        </b-col>
      </template>
      <template v-else>
        <b-col lg="4">
          <FWMLv2SelectorViz :selector="rule.selector"/>
        </b-col>
        <b-col lg="4">from
        <FWMLv2LocatorViz :locator="rule.source" :negate="rule.negate_source"/>
        </b-col>
        <b-col lg="1">
          <FWMLv2ActionViz :action="rule.action"/>
        </b-col>
        <b-col lg="3">to
        <FWMLv2LocatorViz :locator="rule.destination" :negate="rule.negate_destination"/>
        </b-col>
      </template>
      <b-alert variant="secondary" v-if="rule.description">{{ rule.description }}</b-alert>
    </template>
    <template v-else-if="'rules' in rule">
      <b-col lg="12" class="mb-0">
      <FWMLv2RuleViz :rule="r" v-bind:key="r" v-for="r in rule.rules"/>
      </b-col>
    </template>
    <template v-else>
      {{ JSON.stringify(rule) }}
    </template>
  </b-row>
</template>

<script>

import FWMLv2LocatorViz from '@/components/fwml/FWMLv2LocatorViz.vue'
import FWMLv2SelectorViz from '@/components/fwml/FWMLv2SelectorViz.vue'
import FWMLv2ActionViz from '@/components/fwml/FWMLv2ActionViz.vue'

export default {
  name: 'FWMLv2RuleViz',
  components: { FWMLv2ActionViz, FWMLv2SelectorViz, FWMLv2LocatorViz },
  props: {
    rule: {
      type: Object,
      required: true
    }
  },
}
</script>
